import {gql} from 'apollo-boost';
import {STUDENT_NAME_FIELDS, TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_STUDENTSCORE = gql`
  query getStudentScore($id : ID!){
    getStudentScore (
      id: $id
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }

    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTSCORES_BY_FILTER = gql`

  query getStudentScoresByFilter($studentScoreFilterInput: StudentScoreFilterInput){
    getStudentScoresByFilter (
      studentScoreFilterInput:$studentScoreFilterInput
    ){
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
        courseOutlineRegistration {
          id
          courseOutline {
            id
          }
        }
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTSCORES_FOR_TEACHER = gql`

  query getStudentScoresForTeacher($studentScoreFilterInput: StudentScoreFilterInput){
    getStudentScoresForTeacher (
      studentScoreFilterInput:$studentScoreFilterInput
    ){
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode remark
      studentEnrollDetail {
        id
        courseOutlineRegistration {
          id
          courseOutline {
            id
          }
        }
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTSCORES = gql`
  query getStudentScores {
    getStudentScores {

      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const ADD_STUDENTSCORE = gql`
  mutation addStudentScore(
    $classSectionId: ID!
    $studentScoreInput: StudentScoreInput!
  ) {
    addStudentScore(
      classSectionId: $classSectionId
      studentScoreInput: $studentScoreInput
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_STUDENTSCORE = gql`
  mutation updateStudentScore(
    $id: ID!,
    $studentScoreInput: StudentScoreInput!
    $studentScoreDetailsInput: [StudentScoreDetailsInput]
  ) {
    updateStudentScore(
      id: $id
      studentScoreInput: $studentScoreInput
      studentScoreDetailsInput: $studentScoreDetailsInput
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode remark
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_STUDENTSCORE_ARRAY = gql`

  mutation updateStudentScoreArray(
    $studentScoreArrayInput: [StudentScoreArrayInput]
  ) {
    updateStudentScoreArray(
        studentScoreArrayInput: $studentScoreArrayInput
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode remark
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const RECREATE_STUDENTSCORE = gql`
  mutation reCreateStudentScore($classSectionId: ID!) {
    reCreateStudentScore(classSectionId: $classSectionId) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode remark
      studentEnrollDetail {
        id
        courseOutlineRegistration {
          id
          courseOutline {
            id
          }
        }
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const DELETE_STUDENTSCORE = gql`
  mutation deleteStudentScore($id: ID!) {
    deleteStudentScore(
      id: $id
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        ...StudentNameFields
        picturePath
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

